var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRulesImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E7F2F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_15600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3335 8H11.3335C10.8031 8 10.2944 8.21071 9.91928 8.58579C9.54421 8.96086 9.3335 9.46957 9.3335 10V22C9.3335 22.5304 9.54421 23.0391 9.91928 23.4142C10.2944 23.7893 10.8031 24 11.3335 24H22.6668V9.33333C22.6668 8.97971 22.5264 8.64057 22.2763 8.39052C22.0263 8.14048 21.6871 8 21.3335 8V8ZM21.3335 20H13.3335V9.33333H21.3335V20ZM11.3335 9.33333H12.0002V20H11.3448C11.1133 20.002 10.8839 20.0442 10.6668 20.1247V10C10.6668 9.82319 10.7371 9.65362 10.8621 9.5286C10.9871 9.40357 11.1567 9.33333 11.3335 9.33333ZM11.3335 22.6667C11.1576 22.6667 10.9888 22.5972 10.864 22.4733C10.7391 22.3494 10.6682 22.1812 10.6668 22.0053H10.6768C10.6761 21.9173 10.6928 21.8301 10.726 21.7486C10.7592 21.6671 10.8082 21.5929 10.8702 21.5305C10.9322 21.468 11.0059 21.4184 11.0871 21.3846C11.1684 21.3507 11.2555 21.3333 11.3435 21.3333H21.3335V22.6667H11.3335Z",
    fill: "#0D8091"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_15600"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulesImage);
export default __webpack_public_path__ + "static/media/RulesImage.81964e770941dca5d3a68a1a89f5e811.svg";
export { ForwardRef as ReactComponent };